require('./index.scss')

import PropTypes from 'prop-types'
import { cloneElement, isValidElement, useRef, useState } from 'react'

import { translate } from '@/utils/translations'

const ReadMore = ({ children, hasReadMore, target }) => {
  const btnRef = useRef(null)
  const closedOffsetTop = useRef(null)
  const [isExpanded, setIsExpanded] = useState(null)

  const onToggleExpand = e => {
    if (isExpanded === null) {
      // Used on first run. isExpanded has 3 states.
      setIsExpanded(true)
      closedOffsetTop.current = window.scrollY
      return
    }
    if (isExpanded) {
      window.scrollTo(0, closedOffsetTop.current)
    } else {
      closedOffsetTop.current = window.scrollY
    }
    setTimeout(() => {
      setIsExpanded(!isExpanded)
    }, [250])
    e.preventDefault()
  }
  const linkTextKey = isExpanded ? 'read_less' : 'read_more'
  const expandableId = `expandable-${target}`

  const renderList = () => {
    if (isValidElement(children)) {
      return cloneElement(children, { isExpanded })
    }
    return children
  }

  return (
    <>
      <div id={expandableId}>
        {renderList()}
      </div>
      <If condition={hasReadMore}>
        <div className='product-details__read-more d-flex
          justify-content-center'
        >
          <button
            aria-controls={expandableId}
            aria-expanded={isExpanded}
            className={`vst-btn--transparent u-weight--medium`}
            onClick={onToggleExpand}
            ref={btnRef}
          >
            {translate(`common.${linkTextKey}`)}
          </button>
        </div>
      </If>
    </>
  )
}

export default ReadMore

ReadMore.propTypes = {
  children: PropTypes.object.isRequired,
  hasReadMore: PropTypes.bool.isRequired,
  target: PropTypes.string.isRequired
 }
